/* cnr-base/CnRBase.js  */
class CnR {
    
    api_version = "2023-07";
    keyname = "subscriptions-2024-02";
    constructor(opts={}) {
        this.config = {...this.defaults(),...opts};
        this.inject_css()
        
    }
    defaults() {
      return {
        api_version:"2023-07",
        keyname:"subscriptions-2024-02"
      };
    }
    /* shopify cart functions */
    async getCart(url="/cart.js",extended=false,callback=()=>{}) {
        let cart = {};
        return fetch(url) 
			.then(res=>(extended)?res.text():res.json());
    }
    async updateCart(payload) {
	    return fetch(`/cart/update.js`, {
	      method: 'POST',
	      credentials: 'same-origin',
	      headers: {
	        'Content-Type': 'application/json',
	        'X-Requested-With': 'xmlhttprequest'
	      },
	      body: JSON.stringify(payload)
	    }).then((response) => response.json());
	 }
     async changeCart(payload) {
        return fetch(`/cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(payload)
          }).then((response) => response.json());
     }
     async addToCart(payload,callback) {
        return window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
     }

     /* graphql functions */
     async graphql(query,params) {
        return fetch(`/api/${this.api_version}/graphql.json`,{
            method:"POST",
            headers:{
              "content-type":"application/json",
              "X-Shopify-Storefront-Access-Token":this.config.graphql_token
              },
              body:JSON.stringify({query:query,variables:params})
            })
            .then(response=>response.json())
    }
    graphql_sync(query,params) {
        let ajax = new XMLHttpRequest();
        ajax.headers = {
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
        }
        ajax.open("POST",/api/`${this.api_version}/graphql.json`,false)
        ajax.setRequestHeader("Content-Type", "application/json");
        ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
        ajax.send(JSON.stringify({query:query,params:params}));
        return JSON.parse(ajax.responseText);
    }
    gid2id(gid) {
      return parseInt(gid.split("/").pop())
    }
    collapse_query(object) {
      if (object==null) {
          return object;
      }
      switch(object.constructor.name) {
      case "Array":
          return object.map(item=>this.collapse_query(item));
          break;
          case "Object":
              let ret = {};
              Object.keys(object).forEach(key=>{
                  if (object[key]==null) {
                      ret[key] = null;
                      return;
                  }
                  if (object[key].reference) {
                      ret[key] = this.collapse_query(object[key].reference)
                      return;
                      
                  }
                  if (object[key].references) {                        
                      let all = [];
                      object[key].references.nodes.forEach(ref=>{
                          let crv = {};
                          ref.fields.forEach(field=>{
                              crv[field.key]=this.collapse_query(field.value)
                          })
                          all.push(crv)
                      })
                      object[key] = all;
                      
                  }
                  if (object[key].nodes && object[key].nodes.constructor.name=="Array") {
                      ret[key] = this.collapse_query(object[key].nodes);
                  } else {
                      ret[key] = this.collapse_query(object[key])
                  }
              });
              return ret
              break;
          default:
              if (object) {
                  return object;
              }
              
              break;
      }
  }     
     css() {
        return '';
     }
     inject_css() {
        let css = this.css();
        if (css.length>0) {
            let style = document.createElement("style");
            style.id=this.constructor.name.toLowerCase();
            style.textContent = this.css();
            document.querySelector("head").appendChild(style);
        }
        
     }
}
/* cnr-pdp-subscription-widget/pdp-subscription-widget.js  */
class CnRSubscriptionsWidget extends CnR {
    defaults() {
        return {
            default_to_subscription:true,
            onetime_label:"One Time Purchase",
            subscription_label:"Autoship and save",
            delivery_label: "Delivers Every",
            injection_point:".cnr-subscription-widget",
            form_selector:"[data-product-form]",
            krc:true,
            selling_group_index:1,
        };
    }
    constructor(options) {
        super(options);
        this.selling_plans = {}
        this.load_product(this.config.product)
            .then(q=>{
                this.config.product = q.data.product;
                this.config.variants = q.data.product.variants.nodes.map(variant=>{
                  return {
                     id:this.gid2id(variant.id),
                     price:parseFloat(variant.price.amount)
                  };
                });
                if (!this.config.variant_id) {
                  this.config.selected_variant = this.config.variants[0];
                } else {
                  this.config.selected_variant = this.config.variants.find(variant=>variant.id==this.config.selected_variant)
                }
                if (q.data && q.data.product) {
                  if (q.data.product.sellingPlanGroups.nodes.length>0) {
                    let group = q.data.product.sellingPlanGroups.nodes.pop();
                    this.selling_plans = {
                      group_id:group.name,
                      options:group.sellingPlans.nodes.map(selling_plan=>{
                        return {
                          id:this.gid2id(selling_plan.id),
                          label:selling_plan.options[0].value,
                          discount:selling_plan.priceAdjustments[0].adjustmentValue.percent/100,
                        };
                      }),
                    };
                    if (!this.config.selling_plan_id) {
                      if (this.config.default_to_subscription) {
                         this.config.selling_plan= this.selling_plans.options[0];  
                         this.config.last_selling_plan = this.config.selling_plan;
                        }  
                      } else {
                        this.config.selling_plan = this.selling_plans.options.find(plan=>plan.id==this.config.selling_plan_id);
                        this.config.last_selling_plan = this.config.selling_plan;
                      }
                    }        
                  }
                document.addEventListener("CartUpdated",event=>{
                  this.cart = event.detail;
                  this.render();
                });
                document.addEventListener("VariantChanged",event=>{
                  this.config.selected_variant = this.config.variants.find(variant=>variant.id==parseInt(event.detail))
                  this.render();
                });
                this.killReCharge();
                this.render();
            });
   }
  load_product(id) {
    return this.graphql(`
      query getProducts($id: ID!) {
        product(id:$id) {
          id
          variants(first:100) {
            nodes {
              id
              price {
                amount
              }${this.additionalVariantQuery()}
            }
          }
          ${this.additionalProductQuery()}
          sellingPlanGroups(first: 3) {             
            nodes {
              name
              sellingPlans(first:250) {                
                nodes {
                  recurringDeliveries
                  id
                  options {
                    value
                  }
                  description
                  priceAdjustments {
                    adjustmentValue {
                      ... on SellingPlanPercentagePriceAdjustment {
                        percent: adjustmentPercentage
                      }
                      ... on SellingPlanFixedPriceAdjustment {
                        amount: price {
                          amount
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }`,
      {id:`gid://shopify/Product/${id}`}
      );
    }
    additionalVariantQuery() { return '';}
    additionalProductQuery() { return '';}
    regular_price() {
      return this.config.selected_variant.price;
    }
    display_regular_price() {
      return `$${this.regular_price().toFixed(2)}`
    }
    discounted_price() {
      return this.config.selected_variant.price*(1-((this.config.selling_plan)?this.config.selling_plan.discount:this.selling_plans.options[0].discount));
    }
    display_discounted_price() {
      return `$${this.discounted_price().toFixed(2)}`
    }
    killReCharge() {
      this.rci = window.setInterval(()=>{
        let recharge = document.querySelector(".rc-container-wrapper[data-widget-container-wrapper]");
        if (recharge) {
          recharge.parentElement.removeChild(recharge);
          
          window.clearInterval(this.rci)
        }  
      },200)
      
    }
    render() {
      let render_select = (plans)=>{
        return plans.map(plan=>{
          return `
          <option value="${plan.id}" ${(this.config.selling_plan && (this.config.selling_plan.id==plan.id || (this.config.last_selling_plan && this.config.last_selling_plan.id==plan.id)))?'selected':''}>
            ${this.config.delivery_label} ${plan.label}
          </option>`
        })
      }
      let root = document.querySelector(this.config.injection_point);
      root.innerHTML = `
        <div id="rc_container">
          <div id="rc_radio_options" role="radiogroup" aria-labelledby="Purchase options">
            <div class="rc_block rc_block__type rc_block__type__onetime ${!this.config.selling_plan?'rc_block__type--active':''}" >
        		<input type="radio" id="rc_purchase_type_onetime" name="purchase_type" value="onetime" data-selling-plan="" class="rc_radio rc_radio__onetime" ${!this.config.selling_plan?'checked':''} data-purchase-type="onetime">
        		<label for="rc_purchase_type_onetime" class="rc_label rc_label__onetime">
                  ${this.config.onetime_label} 
        		  <span id="rc_price_onetime" class="rc_price rc_price__onetime" aria-label="original price">${this.display_regular_price()}</span>
    			</label>
    		</div>
            <div class="rc_block rc_block__type rc_block__type__autodeliver ${this.config.selling_plan?'rc_block__type--active':''} ${this.selling_plans.options.length>0?'':'d-none'}" >
        		<input type="radio" name="purchase_type" id="rc_purchase_type_autodeliver" value="autodeliver"  class="rc_radio rc_radio__autodeliver" ${this.config.selling_plan?'checked':''} data-purchase-type="autodeliver">
    			<label for="rc_purchase_type_autodeliver" class="rc_label rc_label__autodeliver">
                    ${this.config.subscription_label}
            		<span id="rc_price_autodeliver" class="rc_price rc_price__autodeliver" aria-label="recurring price">${this.display_discounted_price()}</span>
    			</label>
    			<div id="rc_autodeliver_options" class="rc_block rc_block__type__options">
        			<select name="selling_plan_id" id="rc_shipping_interval_frequency" class="rc_select rc_select__frequency styled replaced">
                      ${render_select(this.selling_plans.options)}
                	</select>
    			</div>
    		</div>
          </div>
          ${this.extraHTML()}
        </div>
      `;
      let plan_input = document.querySelector('[name="selling_plan"]');
      if (!plan_input) {
        plan_input = document.createElement("input");
        plan_input.type="hidden";
        plan_input.name="selling_plan";
        document.querySelector(this.config.form_selector).appendChild(plan_input);
      }
      if (plan_input && this.config.selling_plan) {
        plan_input.value = this.config.selling_plan.id;
      }
      root.querySelector("#rc_shipping_interval_frequency").addEventListener("change",event=>{
        let value = event.target.options[event.target.selectedIndex].value;
        this.config.last_selling_plan = this.config.selling_plan;
        this.config.selling_plan = this.selling_plans.options.find(plan=>plan.id==parseInt(value));
        plan_input.value = value;
      })
      root.querySelectorAll('input[name="purchase_type"]').forEach(radio=>{
        radio.addEventListener("click",event=>{          
          
          switch(radio.dataset.purchaseType) {
              case "onetime":
              this.config.last_selling_plan = this.config.selling_plan;
              this.config.selling_plan = null;

              const oneTimePriceWithComma = this.config.selected_variant.price.toString().split(".")
              document.querySelector('[data-product-price]').innerHTML = `$${oneTimePriceWithComma[0]}.<sup>${oneTimePriceWithComma[1]}</sup>`
              
              plan_input.value="";
              break;
            case "autodeliver":
              
              if (this.config.last_selling_plan) {
                this.config.selling_plan = this.config.last_selling_plan;
              } else {
                this.config.selling_plan = this.selling_plans.options[0];
              }
              plan_input.value = this.config.selling_plan.id;
              const subPriceWithComma = (this.config.selected_variant.price * (1 -this.config.selling_plan.discount)).toFixed(2).split(".")
              document.querySelector('[data-product-price]').innerHTML = `$${subPriceWithComma[0]}.<sup>${subPriceWithComma[1]}</sup>`
              break;
          }
          this.render();
          
        });
      })
      
    }
    extraHTML() {
      return '';
    }
}
/* kize.js  */
class KizePdpSubscriptionWidget extends CnRSubscriptionsWidget {
    
    constructor(options) {
        super(options)
    }
    additionalProductQuery() {
        return `
            perBox: metafield(namespace:"custom",key:"items_per_box") {
                value
            }
        `;
    }
    pricePer(price,items) {
        return price/parseInt(items);
    }
    display_regular_price() {
        if (this.config.product.perBox) {
            return `$${this.regular_price().toFixed(2)} <span class="price-per">($${this.pricePer(this.regular_price(),this.config.product.perBox.value).toFixed(2)}/bar)</span>`;
        } else {
            return `$${this.regular_price().toFixed(2)}`
        }
    }
    display_discounted_price() {
        if (this.config.product.perBox) {
            return `$${this.discounted_price().toFixed(2)} <span class="price-per">($${this.pricePer(this.discounted_price(),this.config.product.perBox.value).toFixed(2)}/bar)</span>`;
        } else {
            return `$${this.discounted_price().toFixed(2)}`
        }
    }
    extraHTML() {
      return `
        <div class="rc_popup" data-v-7bc675e0=""><div class="rc_popup__hover acsb-hover" data-v-7bc675e0="" style="--backgroundColor: #cc6d6d;" data-acsb-hover="true" data-acsb-navigable="true" tabindex="0" data-acsb-now-navigable="true"><button class="rc_popup_label_wrapper row" aria-label="Subscription details" aria-expanded="false" data-v-7bc675e0="" data-acsb-clickable="true" data-acsb-force-unnavigable="true" tabindex="-1" data-acsb-now-navigable="false" role="button" data-acsb-navigable="true" data-custom-button-processed="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="#191D48" xmlns="http://www.w3.org/2000/svg" class="reload-icon" data-test-popup-icon="" data-v-7bc675e0="" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true"><path fill="currentColor" d="M13.64 2.35C12.19 0.9 10.2 0 7.99 0C3.57 0 0 3.58 0 8C0 12.42 3.57 16 7.99 16C11.72 16 14.83 13.45 15.72 10H13.64C12.82 12.33 10.6 14 7.99 14C4.68 14 1.99 11.31 1.99 8C1.99 4.69 4.68 2 7.99 2C9.65 2 11.13 2.69 12.21 3.78L8.99 7H15.99V0L13.64 2.35Z"></path></svg><span class="rc_popup__label" data-v-7bc675e0="">Subscription details</span></button><div class="rc_popup__block" data-v-7bc675e0="" style="--backgroundColor: #cc6d6d; background-color: rgb(204, 109, 109); color: rgb(255, 255, 255);" aria-hidden="false" data-acsb-hidden="false"><div class="rc_popup__block__content" data-v-7bc675e0=""><div class="rc_popup__how_it_works" data-v-7bc675e0=""><strong>How subscriptions work</strong><br>Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.</div><a class="rc_popup__learn_more" href="http://rechargepayments.com/subscribe-with-recharge" target="_blank" rel="noopener noreferrer" data-v-7bc675e0="" style="color: rgb(255, 255, 255);" data-acsb-tooltip="New Window" data-acsb-clickable="true" data-acsb-force-unnavigable="true" tabindex="-1" data-acsb-now-navigable="false" data-custom-button-processed="true">Learn more...<span class="acsb-sr-only" data-acsb-sr-only="true" data-acsb-force-visible="true" data-acsb-sr-only-position="after" aria-hidden="false" data-acsb-hidden="false"> - subscribe with recharge - recharge payments New Window</span></a></div><!--v-if--></div></div></div>
      `
    }
    render() {
      super.render();
      
    }
}
